<template>
  <section>
    <!-- 🚨 New date fliter  -->
    <section
      class="rounded-xl bg-[#F5F5F5] w-fit px-1 py-1 flex gap-x-2 text-sm"
    >
      <div v-for="date in dates" :key="date.name">
        <button
          @click="selectedDate = date"
          :class="`${selectedDate.slug === date.slug ? 'bg-white shadow' : ''}
            rounded-xl py-2 px-3 text-neutral-600 font-semibold `"
        >
          {{ date.name }}
        </button>
      </div>

      <button
        @click="triggerCalendar"
        :class="`${selectedDate === 'custom' ? 'bg-white' : ''}
            
            rounded-xl py-2 px-3 text-neutral-600 font-semibold `"
      >
        {{ lowerCase(selectedDate) === "custom" ? dateRangeWords : "Custom" }}

        <section class="hidden">
          <Calendar
            ref="calendar"
            :range="true"
            v-model="dateRange"
            :maxDate="maxDate"
          />
        </section>
      </button>
    </section>
    <!--  -->
  </section>
</template>

<script>
import {
  formatDate,
  formatNumber,
  generateColors,
  getCurrencyCode,
  getEntityQuery,
  shortenNumber,
  translateText,
  lowerCase,
  isBranch,
  currencyFormat,
} from "@/core/helpers/utility";
import moment from "moment";
export default {
  name: "DashboardCalendar",
  emits: ["updateRange"],
  data() {
    return {
      isBranch,
      formatDate,
      translateText,
      formatNumber,
      getCurrencyCode,
      currencyFormat,
      lowerCase,
      shortenNumber,

      selectedDate: "today",

      // 🚨 Date range filter
      dates: [
        {
          name: "Today",
          slug: "today",
          value: {
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        },

        {
          name: "This month",
          slug: "thisMonth",
          value: {
            startDate: moment().startOf("month").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        },
        {
          name: "Last month",
          slug: "lastMonth",
          value: {
            startDate: moment()
              .subtract(1, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            endDate: moment()
              .subtract(1, "month")
              .endOf("month")
              .format("YYYY-MM-DD"),
          },
        },
        // {
        //   name: "Last 30 days",
        //   slug: "last30",
        //   value: {
        //     startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        //     endDate: moment().format("YYYY-MM-DD"),
        //   },
        // },
      ],
      dateRange: {
        startDate: moment()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"),
        endDate: moment()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD"),
      },
      maxDate: moment().format("YYYY-MM-DD hh:mm"),
      //
    };
  },

  mounted() {
    // this.selectedDate = this.dates[0];
    const { startDate, endDate } = this.$route.query;
    if (startDate && endDate) {
      this.dateRange = {
        startDate: startDate,
        endDate: endDate,
      };
      this.selectedDate = "custom";
    } else {
      this.selectedDate = this.dates[0];
    }
  },
  watch: {
    selectedDate(newVal) {
      // console.log("selcted date", newVal);
      if (newVal !== "custom") {
        this.dateRange = newVal.value;
      }
    },

    dateRange() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          startDate: this.dateRange.startDate,
          endDate: this.dateRange.endDate,
        },
      });
      this.$emit("updateRange", this.dateRange);
    },
  },
  computed: {
    dateRangeWords() {
      const { startDate, endDate } = this.dateRange ?? {};
      return `${moment(startDate).format("ll")} - ${moment(endDate).format(
        "ll"
      )}`;
    },
  },

  methods: {
    triggerCalendar() {
      this.selectedDate = "custom";
      this.$refs.calendar.openDatePicker();
    },
  },
};
</script>

<style></style>
